import { render, staticRenderFns } from "./IndagineEpidemiologicaBotulismoViewComponent.vue?vue&type=template&id=16be30d0"
import script from "./IndagineEpidemiologicaBotulismoViewComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaBotulismoViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports